import type { TranslationKey } from './es'

// 简体中文词典 — 必须声明所有 TranslationKey。
const zh: Record<TranslationKey, string> = {
  // ── 通用 ───────────────────────────────────────────────
  'common.refresh': '刷新',
  'common.new': '新建',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.close': '关闭',
  'common.loading': '加载中…',
  'common.all': '全部',
  'common.yes': '是',
  'common.no': '否',
  'common.active': '启用',
  'common.inactive': '禁用',
  'common.discontinued': '已停产',
  'common.status': '状态',
  'common.actions': '操作',
  'common.filters': '筛选',
  'common.category': '分类',
  'common.brand': '品牌',
  'common.name': '名称',
  'common.price': '价格',
  'common.stock': '库存',
  'common.supplier': '供应商',
  'common.product': '产品',
  'common.products': '产品',
  'common.date': '日期',
  'common.client': '客户',
  'common.total': '总计',
  'common.previous': '上一页',
  'common.next': '下一页',
  'common.pageOf': '第 {page} 页，共 {pages} 页 • 总计：{total}',
  'common.allCategories': '所有分类',
  'common.allBrands': '所有品牌',
  'common.allStatuses': '所有状态',
  'common.user': '用户',
  'common.role': '角色',
  'common.email': '电子邮箱',
  'common.optional': '（可选）',
  'common.viewDetails': '查看详情',
  'common.updateStatus': '更新状态',
  'common.error': '错误',
  'common.remove': '移除',

  // ── 角色 ───────────────────────────────────────────────
  'role.superadmin': '超级管理员',
  'role.admin': '管理员',
  'role.client': '客户',
  'role.viewer': '查看者',
  'role.superadminLong': '超级管理员',
  'role.adminLong': '管理员',

  // ── 管理后台布局 ───────────────────────────────────────
  'nav.digestor': '目录处理器',
  'nav.inventory': '库存',
  'nav.suppliers': '供应商',
  'nav.products': '产品',
  'nav.quotations': '订单与报价',
  'nav.sales': '销售',
  'nav.users': '用户',
  'nav.settings': '设置',
  'layout.online': '在线',
  'layout.logout': '退出登录',
  'layout.adminPanel': '管理面板',
  'layout.language': '语言',

  // ── 订单状态 ───────────────────────────────────────────
  'status.pending': '待处理',
  'status.confirmed': '已确认',
  'status.processing': '处理中',
  'status.shipped': '已发货',
  'status.delivered': '已送达',
  'status.cancelled': '已取消',
  'status.refunded': '已退款',

  // ── 报价单状态 ─────────────────────────────────────────
  'qstatus.draft': '草稿',
  'qstatus.sent': '已发送',
  'qstatus.viewed': '已查看',
  'qstatus.approved': '已批准',
  'qstatus.rejected': '已拒绝',
  'qstatus.expired': '已过期',
  'qstatus.converted': '已转化',

  // ── 产品供货状态 ───────────────────────────────────────
  'avail.in_stock': '有库存',
  'avail.low_stock': '库存不足',
  'avail.out_of_stock': '缺货',
  'avail.discontinued': '已停产',
  'avail.pre_order': '可预订',

  // ── 库存 ───────────────────────────────────────────────
  'inv.title': '库存管理',
  'inv.subtitle': '管理产品、库存和供应商',
  'inv.export': '导出',
  'inv.import': '导入',
  'inv.receipt': '收货',
  'inv.history': '历史记录',
  'inv.newProduct': '新建产品',
  'inv.alertsTitle': '库存提醒：',
  'inv.alertsCount': '{count} 个产品库存不足或达到补货点',
  'inv.viewAlerts': '查看提醒',
  'inv.alertsModal': '库存提醒',
  'inv.colAvailable': '可用数量',
  'inv.colMin': '最低库存',
  'inv.colReorder': '补货点',
  'inv.historyModal': '调整历史',
  'inv.colType': '类型',
  'inv.colPrev': '调整前',
  'inv.colNew': '调整后',
  'inv.colReason': '原因',
  'inv.receiptModal': '产品收货',
  'inv.reference': '参考号',
  'inv.refPlaceholder': '采购订单/发票/运单',
  'inv.optionalMark': '（可选）',
  'inv.colProductId': '产品ID',
  'inv.colQuantity': '数量',
  'inv.addRow': '添加行',
  'inv.superTools': '超级管理员工具',
  'inv.superOnly': '仅超级管理员可见',
  'inv.wipeAll': '清空库存和产品',
  'inv.wipeMetrics': '重置全局指标',
  'inv.confirmWipe': '确定要删除所有库存和所有产品吗？（包括库存数量、调整记录、媒体和引用）此操作无法撤销。',
  'inv.confirmResetMetrics': '确定要将仪表板指标重置为零吗？',
  'inv.wiped': '库存已清空',
  'inv.wipeError': '无法清空库存',
  'inv.metricsReset': '指标已重置',
  'inv.metricsResetError': '无法重置指标',
  'inv.searchPh': '按名称或SKU搜索产品…',
  'inv.itemsPerPage': '每页条数',
  'inv.showing': '显示第 {from} - {to} 条，共 {total} 个产品',
  'inv.viewDetails': '查看详情',
  'inv.adjustStock': '调整库存',
  'inv.moreOptions': '更多操作',
  'inv.stockOut': '无库存',
  'inv.stockLow': '库存不足',
  'inv.stockIn': '有库存',
  'inv.adjustTitle': '调整库存 — {name}',
  'inv.adjType': '类型',
  'inv.adjIn': '入库',
  'inv.adjOut': '出库',
  'inv.adjSet': '设定',
  'inv.adjNewStock': '新库存值',
  'inv.adjQuantity': '数量',
  'inv.adjReasonPh': '收货、盘点调整、损耗等',
  'inv.stockAdjusted': '库存已调整',
  'inv.adjustError': '无法调整库存',
  'inv.deleteTitle': '删除产品',
  'inv.deleteConfirm': '确定要删除此产品吗？此操作无法撤销。',
  'inv.editTitle': '编辑产品',
  'inv.reorderPoint': '补货点',
  'inv.loadError': '无法加载产品',
  'inv.updated': '产品已更新',
  'inv.updateError': '更新失败',
  'inv.deleted': '产品已删除',
  'inv.deleteError': '删除失败',
  'inv.receiptSaved': '收货已登记',
  'inv.receiptError': '无法登记收货',
  'inv.addValidRows': '请添加有效行',
  'inv.exportOk': '已导出 {count} 个产品',
  'inv.exportError': '导出失败',
  'inv.uploadOk': '✅ 库存已更新：{count} 个产品处理成功',
  'inv.uploadError': '文件处理失败',
  'inv.testOk': '✅ 测试完成：已处理 {count} 个文件',
  'inv.testError': '处理测试失败',
  'inv.csvHeader': '名称;SKU;分类;品牌;价格;库存;供应商;状态',

  // ── 产品 ───────────────────────────────────────────────
  'prod.title': '产品',
  'prod.new': '新建产品',
  'prod.searchPh': '按名称、SKU或品牌搜索',
  'prod.editTitle': '编辑产品',
  'prod.newTitle': '新建产品',
  'prod.supplierRequired': '供应商 *',
  'prod.select': '请选择…',
  'prod.supplierCode': '供应商编码',
  'prod.supplierSkuPh': '供应商SKU',
  'prod.nameRequired': '名称 *',
  'prod.internalSku': '内部SKU',
  'prod.categoryRequired': '分类 *',
  'prod.availability': '供货状态',
  'prod.none': '未找到产品',
  'prod.deleteTitle': '删除',
  'prod.deleteConfirm': '确定删除此产品吗？',
  'prod.loadError': '无法加载产品',
  'prod.updated': '产品已更新',
  'prod.created': '产品已创建',
  'prod.selectSupplier': '请选择供应商',
  'prod.nameCatRequired': '名称和分类为必填项',
  'prod.saveError': '保存失败',
  'prod.deleted': '产品已删除',
  'prod.deleteError': '删除失败',
  'prod.tabMine': '我的产品',
  'prod.tabCatalog': '供应商目录',
  'prod.catalogNote': '由 Digestor 从供应商目录导入的商品——非自有库存。',
  'prod.allSuppliers': '所有供应商',
  'prod.confidence': '置信度',
  'prod.catalogEmpty': '目录暂无条目——请从 Digestor 导入目录',
  'prod.catalogSearchPh': '搜索目录（名称、SKU、规格）',

  // ── 供应商 ─────────────────────────────────────────────
  'sup.title': '供应商',
  'sup.searchPh': '按名称或编码搜索',
  'sup.colCode': '编码',
  'sup.colLastSync': '最近同步',
  'sup.none': '未找到供应商',
  'sup.editTitle': '编辑供应商',
  'sup.newTitle': '新建供应商',
  'sup.activeField': '启用',
  'sup.loadError': '无法加载供应商',
  'sup.nameCodeRequired': '名称和编码为必填项',
  'sup.saved': '供应商已保存',
  'sup.saveError': '保存失败',
  'sup.deleted': '供应商已删除',
  'sup.deleteError': '删除失败',

  // ── 订单与报价 ─────────────────────────────────────────
  'quo.title': '订单与报价',
  'quo.ordersTab': '订单（{count}）',
  'quo.quotesTab': '报价单（{count}）',
  'quo.searchOrderPh': '按订单号或客户搜索',
  'quo.searchQuotePh': '按客户或ID搜索',
  'quo.colOrderNum': '订单号',
  'quo.colValidUntil': '有效期至',
  'quo.colCreated': '创建时间',
  'quo.noOrders': '暂无订单',
  'quo.noQuotes': '暂无报价记录',
  'quo.orderModalTitle': '更新状态 — {num}',
  'quo.quoteModalTitle': '更新报价单',
  'quo.ordersLoadError': '无法加载订单',
  'quo.quotesLoadError': '无法加载报价单',
  'quo.statusUpdated': '状态已更新',
  'quo.quoteStatusUpdated': '报价状态已更新',
  'quo.updateError': '更新失败',

  // ── 网站目录报价 (catalog_quote_requests) ──
  'cq.tab': '网站报价',
  'cq.tabCount': '网站报价 ({count})',
  'cq.notifTitle': '接收时通知',
  'cq.notifAdminLabel': '团队通知',
  'cq.notifClientLabel': '客户确认',
  'cq.notifAdminOk': '✓ 已通过{via}通知团队',
  'cq.notifClientOk': '✓ 已通过{via}通知客户',
  'cq.notifAdminNone': '团队未通知',
  'cq.notifAdminNoneTitle': '未配置渠道或发送失败 — 查看详情',
  'cq.notifNone': '未发送',
  'cqstatus.nueva': '新',
  'cqstatus.enRevision': '审核中',
  'cqstatus.cotizada': '已报价',
  'cqstatus.enviada': '已发送',
  'cqstatus.cerrada': '已关闭',
  'cq.searchPh': '按编号、客户、邮箱或 WhatsApp 搜索',
  'cq.colNumber': '报价编号',
  'cq.colContact': '联系方式',
  'cq.colItems': '条目',
  'cq.colEstTotal': '预估总额',
  'cq.open': '打开',
  'cq.empty': '暂无目录报价请求',
  'cq.loadError': '无法加载网站报价',
  'cq.updateError': '无法更新报价',
  'cq.saved': '价格已保存',
  'cq.company': '公司',
  'cq.clientNote': '客户备注',
  'cq.globalMargin': '全局利润率 %',
  'cq.applyMargin': '应用价格',
  'cq.aiCalc': '用 AI 计算 (CortexBlood)',
  'cq.aiRunning': '正在询问 AI…',
  'cq.aiDone': 'AI 建议已就绪 — 请审核后应用',
  'cq.aiApply': '应用 AI 建议',
  'cq.aiApplied': '建议已应用到价格',
  'cq.aiFailed': 'AI 未响应 ({reason}) — 可手动定价',
  'cq.total': '总计',
  'cq.colProduct': '产品',
  'cq.colQty': '数量',
  'cq.colCost': '目录成本',
  'cq.colMargin': '利润 %',
  'cq.colSalePrice': '售价',
  'cq.colSubtotal': '小计',
  'cq.noBaseCost': '无基础成本 — 手动或 AI 建议价格',
  'cq.sendWhatsApp': '通过 WhatsApp 发送',
  'cq.sendEmail': '通过邮件发送',
  'cq.waTooltip': '打开 WhatsApp，向客户发送报价',
  'cq.emailTooltipMailto': '打开你的邮件客户端（SMTP 未配置），报价已预填',
  'cq.emailTooltipSmtp': '通过 SMTP 服务器发送报价',
  'cq.sentWhatsApp': '已记录为 WhatsApp 发送',
  'cq.sentEmail': '报价已通过邮件发送',
  'cq.sentEmailClient': '已记录 — 报价已从你的邮箱发送',
  'cq.emailFailed': '邮件发送失败',
  'cq.sentVia': '已于 {at} 通过 {via} 发送',
  'cq.pfTitle': '预发票（形式发票）',
  'cq.pfPending': '尚未生成预发票 — 生成后可下载并发送给客户',
  'cq.pfGenerate': '生成预发票 PDF',
  'cq.pfGenerating': '正在生成 PDF…',
  'cq.pfGenerated': '预发票 {number} 已生成',
  'cq.pfError': '无法处理预发票',
  'cq.pfDownload': '下载 PDF',
  'cq.pfPublicLink': 'PDF 公开链接',
  'cq.pfRefresh': '刷新预览',
  'cq.qtyHint': '批发数量：±1/±10/±100/±1000 按钮或直接输入',

  // ── 销售 ───────────────────────────────────────────────
  'sales.title': '销售',
  'sales.subtitle': '管理平台所有订单和销售',
  'sales.totalOrders': '订单总数',
  'sales.pending': '待处理',
  'sales.totalRevenue': '总收入',
  'sales.thisMonth': '本月',
  'sales.searchPh': '按订单号或客户搜索…',
  'sales.loadingOrders': '订单加载中…',
  'sales.noOrdersFiltered': '没有符合筛选条件的订单',
  'sales.noOrders': '暂无订单记录',
  'sales.colOrder': '订单',
  'sales.colProducts': '产品',
  'sales.itemCount': '{count} 件产品',
  'sales.pageInfo': '第 {page} 页，共 {pages} 页 • 总计：{total} 个订单',
  'sales.modalTitle': '更新订单状态',
  'sales.orderLabel': '订单：',
  'sales.clientLabel': '客户：',
  'sales.newStatus': '新状态',
  'sales.tracking': '物流单号（可选）',
  'sales.trackingPh': '例：1234567890',
  'sales.carrier': '承运商（可选）',
  'sales.carrierPh': '例：DHL、FedEx、UPS',
  'sales.adminNotes': '管理备注（可选）',
  'sales.notesPh': '订单内部备注…',
  'sales.updating': '更新中…',
  'sales.updateBtn': '更新状态',
  'sales.loadError': '销售数据加载失败',
  'sales.statusUpdated': '订单状态已更新',
  'sales.updateError': '订单状态更新失败',

  // ── 用户 ───────────────────────────────────────────────
  'users.title': '用户',
  'users.subtitle': '系统用户管理',
  'users.new': '新建用户',
  'users.searchPh': '按姓名或邮箱搜索',
  'users.colLastLogin': '最近登录',
  'users.colCreated': '创建时间',
  'users.activeFilter': '已启用',
  'users.inactiveFilter': '已禁用',
  'users.never': '从未',
  'users.none': '未找到用户',
  'users.deactivate': '禁用',
  'users.reactivate': '启用',
  'users.editTitle': '编辑用户',
  'users.newTitle': '新建用户',
  'users.newPassword': '新密码（可选）',
  'users.passwordRequired': '密码 *',
  'users.firstName': '名字 *',
  'users.lastName': '姓氏 *',
  'users.loadError': '无法加载用户',
  'users.updated': '用户已更新',
  'users.created': '用户已创建',
  'users.required': '邮箱、密码、名字和姓氏为必填项',
  'users.saveError': '保存失败',
  'users.cantDeactivateSelf': '不能禁用自己的账号',
  'users.deactivated': '用户已禁用',
  'users.reactivated': '用户已启用',
  'users.statusError': '状态更新失败',

  // ── 设置 ───────────────────────────────────────────────
  'set.title': '设置',
  'set.subtitle': '系统与账户状态',
  'set.systemStatus': '系统状态',
  'set.environment': '环境',
  'set.database': '数据库',
  'set.verified': '验证时间',
  'set.connected': '已连接',
  'set.noData': '无数据',
  'set.dbRecords': '数据库记录数',
  'set.yourAccount': '您的账户',
  'set.count.users': '用户',
  'set.count.suppliers': '供应商',
  'set.count.products': '产品',
  'set.count.orders': '订单',
  'set.count.quotations': '报价单',
  'set.count.inventory_items': '库存项',
  'set.count.catalog_items': '统一目录项',
  'set.loadError': '无法加载系统信息',
  'set.uptime': '运行时间',

  // ── 登录 ───────────────────────────────────────────────
  'auth.brandTitle': '智能餐饮管理',
  'auth.brandDesc': '库存、报价和订单一站式平台，专为拉丁美洲的厨师和餐厅打造。',
  'auth.f1Title': '统一库存',
  'auth.f1Desc': '实时库存管理',
  'auth.f2Title': '分钟级报价',
  'auth.f2Desc': '高精度解析多格式Excel',
  'auth.f3Title': '实时分析',
  'auth.f3Desc': '数据驱动决策',
  'auth.welcome': '欢迎回来',
  'auth.welcomeSub': '登录您的面板，管理库存和报价',
  'auth.password': '密码',
  'auth.remember': '记住我',
  'auth.forgot': '忘记密码？',
  'auth.signingIn': '登录中…',
  'auth.signIn': '登录',
  'auth.or': '或',
  'auth.createAccount': '创建新账户',
  'auth.loginError': '登录失败',

  // ── 注册 ───────────────────────────────────────────────
  'reg.title': '创建账户',
  'reg.subtitle': '注册以开始管理您的库存',
  'reg.firstName': '名字',
  'reg.lastName': '姓氏',
  'reg.confirm': '确认密码',
  'reg.firstNameReq': '名字为必填项',
  'reg.lastNameReq': '姓氏为必填项',
  'reg.emailInvalid': '邮箱格式无效',
  'reg.pwdMin': '至少6个字符',
  'reg.pwdMismatch': '两次输入的密码不一致',
  'reg.pwdHint': '建议使用大写字母、数字和符号以提高安全性。',
  'reg.creating': '创建中…',
  'reg.create': '创建账户',
  'reg.hasAccount': '已有账户？',
  'reg.signIn': '去登录',
  'reg.created': '账户创建成功',

  // ── 找回密码 ───────────────────────────────────────────
  'fp.title': '找回密码',
  'fp.desc': '输入您的邮箱，我们将发送找回链接。',
  'fp.send': '发送链接',
  'fp.alert': '找回链接将发送至：{email}（演示）',

  // ── AuthLayout ─────────────────────────────────────────
  'authLayout.b1': '统一库存，分钟级报价',
  'authLayout.b2': '高精度处理多格式Excel',
  'authLayout.b3': '为您的目录优化并同步媒体资源',

  // ── 导入向导 ───────────────────────────────────────────
  'wiz.title': '导入库存（SAP模式）',
  'wiz.supplierOptional': '供应商（可选）',
  'wiz.autoDetect': '自动识别',
  'wiz.autoDetectHint': '如不选择供应商，系统将自动识别文件格式。',
  'wiz.dropActive': '将文件拖放到此处…',
  'wiz.dropIdle': '拖放Excel文件到此处，或点击选择',
  'wiz.formats': '格式：.xlsx、.xls • 单文件最大10MB',
  'wiz.colFile': '文件',
  'wiz.colSize': '大小',
  'wiz.colStatus': '状态',
  'wiz.colProgress': '进度',
  'wiz.emptyQueue': '队列为空',
  'wiz.queued': '排队中',
  'wiz.uploading': '上传中',
  'wiz.processed': '已处理',
  'wiz.failed': '错误',
  'wiz.summary': '排队：{q} • 成功：{p} • 失败：{f}',
  'wiz.process': '开始处理',
  'wiz.pause': '暂停',
  'wiz.clearQueue': '清空队列',
  'wiz.results': '处理结果',
  'wiz.colSupplier': '供应商',
  'wiz.colProducts': '产品数',
  'wiz.colTime': '耗时',
  'wiz.uploadError': '文件上传失败',

  // ── 目录消化器 (CortexCatalogProcessorPage) ──
  'digest.title': '批量目录消化器',
  'digest.formatsBadge': 'Excel · CSV · TXT · PDF · Word · 图片 + 本地AI',
  'digest.subtitle': '上传任意格式/语言的价目表批次。确定性引擎 + CortexBlood AI 将其规范化、去重并合并到全局目录。',
  'digest.aiBadgeSession': 'API 无响应（会话）',
  'digest.aiBadgeLatency': '延迟 {ms}ms',
  'digest.aiBadgeOffline': 'CortexBlood 无响应 — 仅确定性引擎',
  'digest.dropReady': '{n} 个文件待处理',
  'digest.dropHint': '拖放目录批次或点击',
  'digest.dropFormats': '.xlsx .xls .csv .txt .pdf .docx .png .jpg — 任意编码或语言',
  'digest.digestBtn': '消化 {n} 个文件',
  'digest.digesting': '正在消化批次…',
  'digest.addFileErr': '请至少添加一个目录文件',
  'digest.tooLarge': '文件因过大被拒绝（最大 {max}MB）：{names}',
  'digest.jobQueued': '批次已入队：{n} 个文件 — 你可以关闭此标签页，处理将在服务器上继续',
  'digest.jobDone': '批次完成：{ok}/{total} 个文件成功，{n} 个产品已入库',
  'digest.tabCloseNote': '处理在服务器上运行：如果关闭此标签页，可在任务列表中继续查看状态。',
  'digest.uploadMB': '{loaded} / {total} MB',
  'digest.uploading': '上传中 {pct}%',
  'digest.stage.queued': '排队中',
  'digest.stage.reading': '正在读取文档',
  'digest.stage.extracting': '正在提取产品',
  'digest.stage.enriching': 'AI 增强中',
  'digest.stage.ocr': '视觉 OCR',
  'digest.stage.images': '正在提取图片',
  'digest.stage.persisting': '正在写入目录',
  'digest.stage.pages': '第 {done}/{total} 页',
  'digest.stage.ai': 'AI {done}/{total}',
  'digest.stage.inserted': '已保存 {n} 条',
  'digest.stage.products': '{n} 个产品',
  'digest.stage.imagesMatched': '{n} 张照片',
  'digest.jobCompleted': '已完成',
  'digest.jobFailed': '失败',
  'digest.jobProcessing': '处理中',
  'digest.jobSummary': '{ok}/{total} 成功 · {failed} 失败 · {inserted} 已入库 · {dupes} 重复',
  'digest.jobProducts': '{n} 个产品',
  'digest.hybridTag': '确定性 + AI 混合引擎',
  'digest.hybridTitle': '容忍真实供应商的混乱数据',
  'digest.hybridBody': '无固定列顺序。可在任意行检测表头，支持 ES/EN/ZH 同义词（品名, precio, SKU, 单价…），UTF-8/Latin-1/GBK 编码，促销行过滤；置信度低时调用本地 LLM（Ollama）。每个批次经过 CortexBlood：名称翻译与规范化、统一分类，然后语义扫描检测哈希无法捕获的重复项。',
  'digest.featBatch': '批量',
  'digest.featBatchBody': '每批 100+ 文件，单文件失败互不影响',
  'digest.featDedup': 'AI 去重',
  'digest.featDedupBody': '精确哈希 + LLM 语义确认',
  'digest.featAI': '全程 AI',
  'digest.featAIBody': 'CortexBlood 增强并翻译每个产品',
  'digest.dedupTitle': 'AI 检测到的重复项',
  'digest.dedupSub': 'CortexBlood 对目录的二次扫描 — 每批后自动运行 · 同一产品，不同名称/供应商',
  'digest.dedupScanning': '正在分析 {items} 项 · {ok}/{total} 组…',
  'digest.dedupBtn': '用 CortexBlood 扫描',
  'digest.dedupEmptyDone': '扫描完成 — 无确认的语义重复',
  'digest.dedupEmpty': '无待处理组。运行 AI 扫描以检测语义重复。',
  'digest.dedupMerge': '合并',
  'digest.dedupDismiss': '不是重复',
  'digest.dedupCanonical': '规范项',
  'digest.dedupDupPct': '{pct}% 重复',
  'digest.dedupScanToast': 'AI 扫描：{total} 个候选中确认 {ok} 个重复组',
  'digest.dedupScanFail': 'AI 扫描失败：{err}',
  'digest.dedupScanStart': 'CortexBlood 正在扫描语义重复…',
  'digest.dedupLaunchFail': '无法启动扫描',
  'digest.dedupMerged': '已合并：{n} 项被吸收',
  'digest.dedupDismissed': '组已忽略',
  'digest.dedupResolveFail': '无法处理',
  'digest.netError': '网络错误：{err}',
  'digest.catalogTitle': '统一目录',
  'digest.catalogStats': '{items} 个产品 · {suppliers} 个供应商',
  'digest.catalogAiItems': '{n} 项经 AI 规范化',
  'digest.searchPlaceholder': '搜索名称 / SKU / 规格…',
  'digest.allSuppliers': '所有供应商',
  'digest.allCategories': '所有分类',
  'digest.filterBtn': '筛选',
  'digest.colProduct': '产品',
  'digest.colSku': 'SKU',
  'digest.colSupplier': '供应商',
  'digest.colCategory': '分类',
  'digest.colSpec': '规格 / 容量 / 功率',
  'digest.colPrice': '价格 USD',
  'digest.colStock': '库存',
  'digest.colConf': '置信度',
  'digest.colSource': '来源',
  'digest.catalogEmpty': '暂无产品。请在上方消化一批目录。',
  'digest.pagination': '{total} 个产品 · 第 {page} 页，共 {pages} 页',
  'digest.prevPage': '← 上一页',
  'digest.nextPage': '下一页 →',
  'digest.aiExtractTitle': '由 LLM 完整提取',
  'digest.aiEnhanceTitle': '由 CortexBlood 规范化/增强的产品',
  // 具体错误（后端 errorCode → i18n）
  'digest.err.pdfScanned': '扫描版 PDF 无文本层 — 需要视觉 OCR',
  'digest.err.pdfPassword': 'PDF 受密码保护 — 请移除密码后重新上传',
  'digest.err.pdfCorrupt': 'PDF 损坏或被截断',
  'digest.err.pdfUnreadable': '无法读取该 PDF',
  'digest.err.unsupported': '不支持该文件类型',
  'digest.err.badSpreadsheet': '无法作为电子表格读取',
  'digest.err.badDocx': '无法读取该 Word 文档',
  'digest.err.fileUnreadable': '无法从磁盘读取该文件',
  'digest.err.interrupted': '因服务重启而中断 — 请重新上传',
  'digest.err.empty': '无法从文件中提取任何可读表格',
  'digest.err.noProducts': '文件中未找到产品',
  'digest.err.unknown': '未知的提取错误',
  'digest.err.tooLargeHttp': '文件超过服务器限制（每个文件 {max}MB）',
  'digest.err.timeout': '上传超时 — 连接过慢或文件过大',
  'digest.err.network': '无法连接服务器 — 请检查网络',
  'digest.err.batch': '批次入队失败（HTTP {status}）',
  // ── 潜在客户 ──
  'nav.prospects': '潜在客户',
  'nav.cotizaia': 'cotizaIA 智能报价',
  'pros.title': '潜在客户',
  'pros.aiOnline': '在线',
  'pros.aiOffline': '离线',
  'pros.hideSearch': '隐藏搜索',
  'pros.newSearch': '新建搜索',
  'pros.discoverTitle': '在整个美洲发现潜在客户',
  'pros.stepCountry': '1. 国家',
  'pros.stepRegion': '2. {label}',
  'pros.selectRegion': '— 选择{label} —',
  'pros.stepCities': '3. 城市',
  'pros.citiesIn': '（{province} 共 {n} 个）',
  'pros.pickRegionFirst': '↑ 请先选择{label}',
  'pros.stepSegments': '4. 细分行业',
  'pros.stepKeywords': '5. 关键词（可选，逗号分隔）',
  'pros.keywordsPh': '海鲜、披萨、寿司…',
  'pros.stepLimit': '6. 上限：{n} 个客户',
  'pros.allCountries': '所有国家',
  'pros.colCountry': '国家',
  'pros.searching': '搜索中…',
  'pros.searchIn': '在 {n} 个{cities}中搜索',
  'pros.cityOne': '城市',
  'pros.cityMany': '城市',
  'pros.sourcesNote': '免费来源：OpenStreetMap/Overpass + 网页搜索 · CortexBlood 评分',
  'pros.starting': '启动中…',
  'pros.progress': '城市 {done}/{total} · 已找到 {found} 个客户',
  'pros.resultSummary': '{inserted} 新增 · {found} 找到 · {duplicates} 已存在 · {scored} 经 AI 评分',
  'pros.aiUnavailable': ' · AI 不可用（无评分）',
  'pros.sourcesFailed': '无响应的来源：{list}',
  'pros.searchFailed': '搜索失败',
  'pros.totalCount': '{n} 个客户',
  'pros.plural': '个客户',
  'pros.withScore': '有 fit_score',
  'pros.avgScore': '（平均 {avg}）',
  'pros.searchPh': '按名称、地址或菜系搜索',
  'pros.allSegments': '所有行业',
  'pros.scoreAll': '评分：全部',
  'pros.colBusiness': '商家',
  'pros.colSegment': '行业',
  'pros.colCity': '城市',
  'pros.colContact': '联系方式',
  'pros.colScore': '匹配分',
  'pros.empty': '暂无客户 — 请在上方发起搜索',
  'pros.noScore': '无 AI 评分',
  'pros.aiReasonNotes': 'AI 理由与备注',
  'pros.aiAnalysis': 'AI 分析',
  'pros.noAnalysis': '无分析 — 发现时 AI 不可用',
  'pros.source': '来源：{src}',
  'pros.notes': '备注',
  'pros.notesPh': '跟进、联系、下一步…',
  'pros.saveNote': '保存备注',
  'pros.noteSaved': '备注已保存',
  'pros.pagination': '共 {total} 个 · 第 {page}/{pages} 页',
  'pros.loadError': '无法加载客户列表',
  'pros.cityRequired': '请至少选择一个城市',
  'pros.segmentRequired': '请至少选择一个行业',
  'pros.searchStarted': '搜索已开始 — 可能需要几分钟',
  'pros.searchStartError': '无法启动搜索',
  'pros.updateError': '无法更新',
  'pros.jobDone': '{inserted} 个新客户（共找到 {found} 个）',
  'pros.jobDoneScored': '，{scored} 个经 AI 评分',
  'pros.statusChanged': '状态 → {status}',
  'pros.approach': '切入点',
  'pstatus.new': '新',
  'pstatus.contacted': '已联系',
  'pstatus.qualified': '已合格',
  'pstatus.discarded': '已丢弃',

  // ── 管理端目录（CatalogPage） ──
  'nav.catalog': '目录',
  'cat.title': '目录',
  'cat.subtitle': '从供应商目录中解析的全部商品 — 可按每个属性筛选',
  'cat.searchPh': '按名称、SKU 或规格搜索…',
  'cat.moreFilters': '更多筛选',
  'cat.brandPh': '品牌（在名称或规格中）',
  'cat.capacity': '容量',
  'cat.capacityPh': '例如：16L、350ml',
  'cat.power': '功率',
  'cat.powerPh': '例如：410W、60,000 BTU',
  'cat.dimensions': '尺寸',
  'cat.dimensionsPh': '例如：120 x 90',
  'cat.unit': '单位',
  'cat.allUnits': '所有单位',
  'cat.priceMin': '最低价（美元）',
  'cat.priceMax': '最高价（美元）',
  'cat.confAny': '任意置信度',
  'cat.confMid': '中等或以上（≥50%）',
  'cat.confHigh': '仅高（≥80%）',
  'cat.hasImage': '有图片',
  'cat.inStock': '有库存',
  'cat.clear': '清除筛选',
  'cat.loadError': '无法加载目录',
  'cat.empty': '当前筛选无结果 — 请调整搜索条件',
  'cat.pagination': '共 {total} 个产品 · 第 {page}/{pages} 页',
  'cat.noPhoto': '无图片',
  'cat.askPrice': '询价',


  // ── 配送物流（供应商发现） ──
  'logi.aiAnalysis': 'AI 分析',
  'logi.aiOffline': '离线',
  'logi.aiOnline': '在线',
  'logi.aiReasonNotes': 'AI 理由与备注',
  'logi.aiUnavailable': 'AI 不可用 — 结果无评分',
  'logi.allCountries': '所有国家',
  'logi.allTypes': '所有类型',
  'logi.approach': '切入点',
  'logi.avgScore': '平均分 {avg}',
  'logi.channelActive': '标记为活跃渠道',
  'logi.citiesIn': '（{province} 共 {n} 个）',
  'logi.cityMany': '个城市',
  'logi.cityOne': '个城市',
  'logi.cityRequired': '请至少选择一个城市',
  'logi.colCity': '城市',
  'logi.colContact': '联系方式',
  'logi.colCountry': '国家',
  'logi.colProvider': '供应商',
  'logi.colScore': '评分',
  'logi.colType': '类型',
  'logi.discoverTitle': '发现配送供应商',
  'logi.empty': '暂无供应商 — 请在上方发起发现',
  'logi.hideSearch': '隐藏搜索',
  'logi.jobDone': '发现 {found} 个，新增 {inserted} 个',
  'logi.jobDoneScored': ' · {scored} 个已评分',
  'logi.keywordsPh': '如：delivery、moto、courier',
  'logi.loadError': '无法加载供应商',
  'logi.newSearch': '新的搜索',
  'logi.noAnalysis': '无 AI 分析',
  'logi.noScore': '无评分',
  'logi.notes': '备注',
  'logi.noteSaved': '备注已保存',
  'logi.notesPh': '内部备注…',
  'logi.pagination': '共 {total} 个供应商 · 第 {page}/{pages} 页',
  'logi.pickRegionFirst': '请先选择{label}',
  'logi.plural': '个供应商',
  'logi.progress': '{done}/{total} 城市 · 已发现 {found} 个',
  'logi.resultSummary': '新增 {inserted} · 发现 {found} · 重复 {duplicates} · 已评分 {scored}',
  'logi.saveNote': '保存',
  'logi.scoreAll': '全部评分',
  'logi.searchFailed': '搜索失败',
  'logi.searchIn': '在 {n} {cities}搜索',
  'logi.searching': '搜索中…',
  'logi.searchPh': '搜索供应商…',
  'logi.searchStarted': '发现已启动',
  'logi.searchStartError': '无法启动发现',
  'logi.selectRegion': '选择{label}',
  'logi.source': '来源：{src}',
  'logi.sourcesFailed': '失败来源：{list}',
  'logi.sourcesNote': '来源：公开目录、地图和本地网络（仅公开数据）',
  'logi.starting': '正在启动…',
  'logi.statusChanged': '状态 → {status}',
  'logi.stepCities': '城市',
  'logi.stepCountry': '国家',
  'logi.stepKeywords': '关键词（可选）',
  'logi.stepLimit': '每城市上限：{n}',
  'logi.stepRegion': '{label}',
  'logi.stepTypes': '供应商类型',
  'logi.title': '配送物流',
  'logi.typeRequired': '请至少选择一种供应商类型',
  'logi.updateError': '无法更新',
  'logi.withScore': '已评分',
  'lstatus.new': '新',
  'lstatus.contacted': '已联系',
  'lstatus.negotiating': '洽谈中',
  'lstatus.active_channel': '活跃渠道',
  'lstatus.discarded': '已放弃',

  // ── 上传向导（库存导入） ──

}

export default zh
